import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';

const RegistrationSuccess = (props) => {
    return (
        <Container className="mt-3">
            <h1 className="mb-3">A jéje</h1>
            <p>Tuhle adresu neznáme. Zkus jít na <Link to="/">hlavní stránku</Link> a kouknout na nějaké Bloglettery.</p>
        </Container> 
    )
}

export default RegistrationSuccess;